import { render, staticRenderFns } from "./address-follow-query.vue?vue&type=template&id=cbcb4ae4"
import script from "./address-follow-query.vue?vue&type=script&lang=ts"
export * from "./address-follow-query.vue?vue&type=script&lang=ts"
import style0 from "./address-follow-query.vue?vue&type=style&index=0&id=cbcb4ae4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports